import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes, LINE_ITEM_HOUR } from '../../util/types';
import { getRentalChargeSummary } from '../../util/rentalPricing';
import { chargedDaysFromBookingRange } from '../../util/rentalBookingDates';

import css from './OrderBreakdown.module.css';

const LineItemBasePriceMaybe = props => {
  const { lineItems, code, intl, listing, booking } = props;
  const isNightly = code === LINE_ITEM_NIGHT;
  const isDaily = code === LINE_ITEM_DAY;
  const isHourly = code === LINE_ITEM_HOUR;
  const translationKey = isNightly
    ? 'OrderBreakdown.baseUnitNight'
    : isDaily
      ? 'OrderBreakdown.baseUnitWeek'
      : isHourly
        ? 'OrderBreakdown.baseUnitHour'
        : 'OrderBreakdown.baseUnitQuantity';

  const unitPurchase = lineItems.find(item => item.code === code && !item.reversal);

  const quantity = unitPurchase ? unitPurchase.quantity.toString() : null;
  const unitPrice = unitPurchase ? formatMoney(intl, unitPurchase.unitPrice) : null;
  const total = unitPurchase ? formatMoney(intl, unitPurchase.lineTotal) : null;

  const chargedDays =
    isDaily && booking?.attributes
      ? chargedDaysFromBookingRange(booking.attributes.start, booking.attributes.end)
      : null;
  const rentalSummary =
    isDaily && listing && chargedDays ? getRentalChargeSummary(listing, chargedDays) : null;
  const rentalSummarySub =
    rentalSummary && rentalSummary.unitMoney
      ? intl.formatMessage(
          {
            id:
              rentalSummary.billedAs === 'daily'
                ? 'OrderBreakdown.rentalTotalDailySub'
                : 'OrderBreakdown.rentalTotalWeeklySub',
          },
          {
            unitPrice: formatMoney(intl, rentalSummary.unitMoney),
            rentalDays: rentalSummary.chargedDays,
          }
        )
      : null;

  return quantity && total ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id={translationKey} values={{ unitPrice, quantity }} />
        {rentalSummarySub ? <span className={css.rentalTotalSub}>{rentalSummarySub}</span> : null}
      </span>
      <span className={css.itemValue}>{total}</span>
    </div>
  ) : null;
};

LineItemBasePriceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  code: propTypes.lineItemUnitType.isRequired,
  intl: intlShape.isRequired,
  listing: propTypes.listing,
  booking: propTypes.booking,
};

export default LineItemBasePriceMaybe;
